import { h, Fragment } from "preact";
import { useState, useRef, useEffect, useContext } from "preact/hooks";

import palette from "../../theme/palette";
import typography from "../../theme/typography";
import { Box, Button, Card, CardMedia, CardActions, CardActionArea, Grid, Paper, Typography } from "@mui/material/";

import IconButton from "@mui/material/IconButton";
import GpsFixedIcon from "@mui/icons-material/GpsFixed";
import ArrowDropDownIcon from "@mui/icons-material/ArrowDropDown";
import ButtonGroup from "@mui/material/ButtonGroup";
import ClickAwayListener from "@mui/material/ClickAwayListener";
import Grow from "@mui/material/Grow";
import Popper from "@mui/material/Popper";
import MenuItem from "@mui/material/MenuItem";
import MenuList from "@mui/material/MenuList";
import { makeStyles } from "@mui/styles";
import NavPrimaryButtonMk2 from "../../theme/NavPrimaryButtonMk2";
import Picto1 from "./Picto1";
import Picto2 from "./Picto2";
import Picto3 from "./Picto3";
import Picto4 from "./Picto4";
import Picto5 from "./Picto5";
import Picto6 from "./Picto6";
import Picto7 from "./Picto7";
import Picto8 from "./Picto8";
import Picto9 from "./Picto9";
import Picto10 from "./Picto10";
import Picto11 from "./Picto11";
import Picto12 from "./Picto12";
import Arrow from "./Arrow";
import k from "./k";
import useScrollPosition from "@react-hook/window-scroll";

import { SessionContext } from "../../SessionContext";

const PicLine = (props) => {
	return (
		<Box display="flex" justifyContent="space-between" alignItems="flex-start" m={1} p={1}>
			<Box p={1}>{props.picto}</Box>
			<Box p={1}>
				<Typography variant="h4" display="inline">
					{props.txt}
				</Typography>
			</Box>
		</Box>
	);
};

const Border = (flg) => {
	if (flg) {
		return " border: 1px solid #FF3426";
	} else {
		return "";
	}
};

const MainCard = (props) => {
	return (
		<Box
			m={1}
			p={1}
			borderRadius={32}
			boxShadow={4}
			bgcolor={palette.lightgray}
			padding="10px"
			minWidth="290px"
			//css={Border(true)}
			style={"height: 100%;" + Border(props.border)}
		>
			<Box display="flex" flexDirection="column" justifyContent="space-between" m={1} p={1}>
				<Box p={1}>
					<Typography variant="h2">Devenir</Typography>
					<Typography variant="h2">{props.txt}</Typography>
				</Box>

				<Box p={1}>
					<Typography variant="h3">{props.secTxt}</Typography>
				</Box>
				<Box p={1}>
					<PicLine txt={props.txt1} picto={props.picto1} />
				</Box>
				<Box p={1}>
					<PicLine txt={props.txt2} picto={props.picto2} />
				</Box>
				<Box p={1}>
					<PicLine txt={props.txt3} picto={props.picto3} />
				</Box>
				<Box p={1}>
					<PicLine txt={props.txt4} picto={props.picto4} />
				</Box>
				<Box p={1}>
					<NavPrimaryButtonMk2 href="/" txt="En savoir plus >" />
				</Box>
			</Box>
		</Box>
	);
};

const options1 = ["Ville", "Paris", "Marseille", "Lyon", "Bordeaux", "Je précise ailleurs"];

const options2 = ["Bien", "Appartement", "Maison"];

const options3 = ["Budget", "Sous 100 k", "100 à 300k", "300 à 600k", "au dessus-de 600k"];

const useStyles = makeStyles((theme) => ({
	root: {
		flexGrow: 1,
	},
	menuButton: {
		marginRight: theme.spacing(2),
	},
	title: {
		flexGrow: 1,
	},
	section: { marginTop: theme.spacing(4), marginBottom: theme.spacing(4) },
	section2: {
		marginTop: theme.spacing(3),
		marginBottom: theme.spacing(1),
		marginRight: theme.spacing(20),
		marginLeft: theme.spacing(20),
		background: { k },
	},
	iconButton: {
		padding: 10,
	},
	input: {
		marginLeft: theme.spacing(1),
		flex: 1,
	},
	footer: {
		bottom: 0,
	},
	popover: {
		pointerEvents: "none",
	},
	paper: {
		padding: theme.spacing(1),
	},
	sectionDesktop: {
		display: "none",
		[theme.breakpoints.up("sm")]: {
			display: "flex",
		},
	},
	sectionMobile: {
		display: "flex",
		[theme.breakpoints.up("md")]: {
			display: "none",
		},
	},
	mediaRoot: {},
	media: {
		height: 140,
	},
}));

const CardAnnuary = (props) => {
	const classes = useStyles();

	return (
		<Card className={classes.mediaRoot}>
			<CardActionArea>
				<CardMedia className={classes.media} image={"/images/" + props.txt + ".jpeg"} title={props.txt} />
			</CardActionArea>
			<CardActions style="padding-top: 0px; padding-bottom: 0px;">
				<Box
					display="flex"
					alignItems="center"
					justifyContent="center"
					p={1}
					m={1}
					style="padding-top: 0px; padding-bottom: 0px; margin-top: 0px; margin-bottom: 0px;"
				>
					<Box p={1}>
						<Typography variant="h3" color="primary" style="margin-bottom: 0px">
							{props.txt}
						</Typography>
					</Box>
					<Box p={1}>
						<Button size="small" color="primary">
							<Arrow />
						</Button>
					</Box>
				</Box>
			</CardActions>
		</Card>
	);
};

const SearchBar = () => {
	const [state, setState] = useContext(SessionContext);
	const [bien, setBien] = useState(null);
	const [budget, setBudget] = useState(null);
	const [loc, setLoc] = useState(null);
	const [btnSearch, setBtnSearch] = useState(true);
	const scrollY = useScrollPosition(10 /*fps*/);
	const setCriter = (idx, val) => {
		if (idx == 1) {
			setLoc(val);
		}
		if (idx == 2) {
			setBien(val);
		}
		if (idx == 3) {
			setBudget(val);
		}
	};

	useEffect(() => {
		if (bien !== null && budget !== null && loc !== null) {
			setBtnSearch(false);
		}
	}, [bien, budget, loc]);

	useEffect(() => {
		if (scrollY > 220) {
			setState({ ...state, minibar: true });
		}
		if (scrollY < 220) {
			setState({ ...state, minibar: false });
		}
	}, [scrollY]);

	return (
		<Paper
			elevation={3}
			style={{
				minWidth: "700px",
				borderRadius: 32,
				paddingLeft: "30px",
				zIndex: 2000,
			}}
		>
			<Box display="flex" justifyContent="space-between" p={1} m={1} css={({ width: "100%" }, { padding: "0px" })} alignItems="center">
				<Box p={1}>{true && <SelectSearch tl="Ville" options={options1} setVal={setCriter} idx={1} />}</Box>
				<Box p={1}>{true && <SelectSearch tl="Bien" options={options2} setVal={setCriter} idx={2} />}</Box>
				<Box p={1}>{true && <SelectSearch tl="Budget" options={options3} setVal={setCriter} idx={3} />}</Box>{" "}
				<Box p={1}>
					<IconButton color="secondary" aria-label="add an alarm" href="/trouver-mon-appartement" disabled={btnSearch}>
						<GpsFixedIcon />
					</IconButton>
				</Box>
			</Box>
		</Paper>
	);
};

const Home2 = () => {
	const classes = useStyles();

	return (
		<div style="background-image: url('/images/k.svg'); background-position: left;  background-repeat: no-repeat; background-attachment: fixed;">
			{/*		<script>
window.onscroll = function() {myFunction()};

function myFunction() {
  if (document.body.scrollTop > 350 || document.documentElement.scrollTop > 350) {
  console.log("zsx");
  }
}
</script>*/}
			<div className={classes.sectionDesktop}>
				<section
					style={{
						width: "100%",
						background: "center url('/images/1057186490.jpeg')",
						marginTop: "-0px",
						borderBottomRightRadius: "40px",
						borderBottomLeftRadius: "40px",
						height: "591px",
						paddingBottom: "200px",
					}}
				>
					<Box display="flex" alignItems="center" justifyContent="center" flexDirection="column" p={1} m={1} css={{ height: "100%" }}>
						<Box p={1}>
							<SearchBar />
						</Box>
					</Box>
				</section>
			</div>
			<section className={classes.section2}>
				<Box display="flex" alignItems="center" justifyContent="center" flexDirection="column" p={1} m={1} css={{ height: "100%" }}>
					<Box p={1}>
						<Typography variant="h1" color="primary">
							L'immobilier qui rapporte
						</Typography>
					</Box>
				</Box>
				<Typography variant="subtitle1">Comment ça marche ?</Typography>
			</section>
			<section className={classes.section2} style="height: 100%; ">
				<Grid container>
					<Grid item xs={12} md={4}>
						<MainCard
							border={false}
							txt="Acquéreur"
							secTxt="Localisez votre bien avec son adresse exacte, unique sur le marché !"
							txt1="Accédez à l'intégralité du dossier de vente en 1 clic"
							txt2="Bénéficiez d'une transparence totale sur les informations"
							txt3="Prenez RDV et effectuez 100% des démarches en ligne"
							txt4="Les honoraires sont à la charge du vendeur"
							picto1={<Picto1 />}
							picto2={<Picto2 />}
							picto3={<Picto3 />}
							picto4={<Picto4 />}
						/>
					</Grid>
					<Grid item xs={12} md={4}>
						<MainCard
							border={false}
							txt="Vendeur"
							secTxt="Vendez votre bien aux meilleures conditions du marché !"
							txt1="Bénéficiez des services de la seule agence immobilière 100% en ligne"
							txt2="Estimez votre bien et bénéficiez d'une valeur ajustée en temps réels"
							txt3="Vendez votre bien aux meilleures conditions financières pour vous"
							txt4="Des honoraires les plus bas du marché: X%"
							// txt4="Des honoraires les plus bas du marché: 2% plafonnés à 4800€"
							picto1={<Picto5 />}
							picto2={<Picto6 />}
							picto3={<Picto7 />}
							picto4={<Picto8 />}
						/>
					</Grid>
					<Grid item xs={12} md={4}>
						<MainCard
							border={true}
							txt="Ambassadeur"
							secTxt="Gagnez jusqu’à 2000€ par vente !"
							txt1="Inscrivez-vous en seulement 3 clics"
							txt2="Percevez 50% de la commission de vente"
							txt3="Une offre ouverte à tout le monde: étudiant, salarié, retraité, chômeur..."
							txt4="Aucune formalité administrative et aucun statut social exigé"
							picto1={<Picto9 />}
							picto2={<Picto10 />}
							picto3={<Picto11 />}
							picto4={<Picto12 />}
						/>
					</Grid>
				</Grid>
			</section>
			<section className={classes.section2}>
				<Box display="flex" alignItems="center" justifyContent="center" flexDirection="column" p={1} m={1} css={{ height: "100%" }}>
					<Box p={1}>
						<Typography variant="h2" color="primary">
							Les biens du moment
						</Typography>
					</Box>
					<Box p={1}>
						<Typography variant="h3">S’installer dans une des villes de France, changer de logement... des démarches simples et rapides</Typography>
					</Box>
				</Box>

				<Box display="flex" p={1}>
					<Box p={1} flexGrow={3}>
						<CardAnnuary txt="Paris" />
					</Box>
					<Box p={1} flexGrow={1}>
						<CardAnnuary txt="Cannes" />
					</Box>
					<Box p={1} flexGrow={1}>
						<CardAnnuary txt="Nice" />
					</Box>
				</Box>
				<Box display="flex" p={1}>
					<Box p={1} flexGrow={1}>
						<CardAnnuary txt="Nantes" />
					</Box>
					<Box p={1} flexGrow={1}>
						<CardAnnuary txt="Bordeaux" />
					</Box>
					<Box p={1} flexGrow={3}>
						<CardAnnuary txt="Toulouse" />
					</Box>
				</Box>
			</section>
			<section className={classes.section2}>
				<Grid container>
					<Grid item xs={4}>
						{" "}
						<Typography variant="h2" color="primary" display="block" style="margin-bottom: 10px;">
							Partagez votre expérience
						</Typography>
						<Typography variant="h4" display="block" style="margin-bottom: 10px;">
							Ingrid, Acquéreur
						</Typography>
						<Typography variant="body2" display="block" style="margin-bottom: 10px;">
							“Lorem ipsum dolor sit amet, consectetuer adipiscing elit, sed diam nonummy nibh euismod tincidunt ut laoreet dolore magna aliquam erat
							volutpat. Ut wisi enim ad minim veniam, quis nostrud exerci. ”
						</Typography>
						<NavPrimaryButtonMk2 href="/" txt="Commencer >" />
					</Grid>
					<Grid item xs={8}>
						<img src="/images/img7.jpg" style="width: 100%; height: auto; border-radius: 20px;" />
					</Grid>
				</Grid>
			</section>
		</div>
	);
};

export default Home2;

const SelectSearch = ({ options, idx, setVal }) => {
	const [open, setOpen] = useState(false);
	const anchorRef = useRef(null);
	const [selectedIndex, setSelectedIndex] = useState(0);

	const handleClick = () => {
		console.info(`You clicked ${options[selectedIndex]}`);
	};

	const handleMenuItemClick = (event, index) => {
		setVal(idx, options[index]);
		setSelectedIndex(index);
		setOpen(false);
	};

	const handleToggle = () => {
		setOpen((prevOpen) => !prevOpen);
	};

	const handleClose = (event) => {
		if (anchorRef.current && anchorRef.current.contains(event.target)) {
			return;
		}

		setOpen(false);
	};
	return (
		<Fragment>
			<ButtonGroup variant="text" ref={anchorRef} aria-label="Budget button">
				<Button onClick={handleToggle} style="border: none;">
					<Typography variant="body1">{options[selectedIndex]}</Typography>
				</Button>

				<Button
					color="primary"
					size="small"
					aria-controls={open ? "split-button-menu" : undefined}
					aria-expanded={open ? "true" : undefined}
					aria-label="select merge strategy"
					aria-haspopup="menu"
					onClick={handleToggle}
				>
					<ArrowDropDownIcon />
				</Button>
			</ButtonGroup>
			<Popper open={open} anchorEl={anchorRef.current} role={undefined} transition disablePortal>
				{({ TransitionProps, placement }) => (
					<Grow
						{...TransitionProps}
						style={{
							transformOrigin: placement === "bottom" ? "center top" : "center bottom",
						}}
					>
						<Paper>
							<ClickAwayListener onClickAway={handleClose}>
								<MenuList id="split-button-menu">
									{options.map((option, index) => (
										<MenuItem key={option} selected={index === selectedIndex} onClick={(event) => handleMenuItemClick(event, index)}>
											<Typography variant="body1">{option}</Typography>
										</MenuItem>
									))}
								</MenuList>
							</ClickAwayListener>
						</Paper>
					</Grow>
				)}
			</Popper>
		</Fragment>
	);
};
